/* @flow */
const projectRoutes = {
  archiveProject: 'project/:projectGuid/archive',
  activity: 'projects/:projectId/activity',
};

export default projectRoutes;
